import styled from 'styled-components';

export default styled.div`
  .textField-area-wrap {
    height: auto;
    textarea {
      padding-top: 10px;
    }
  }
  .checkbox-radio-disabled-color .Mui-disabled {
    color: darkgray;
  }
  .textField-area-line-wrap {
    .MuiOutlinedInput-root {
      border: 1px solid #ccc;
      /* border-top: none; */
    }
    .MuiInputLabel-root {
      padding-left: 8px;
      padding-right: 10px;
      background: #fff;
    }
  }
  .button-wrap {
    .Mui-disabled {
      color: #fff;
      box-shadow: 0 0 1px 0 rgb(0 0 0 / 31%), 0 2px 2px -2px rgb(0 0 0 / 25%);
      background-color: #1565c0;
    }
  }
  .tag-flg-style {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    border-bottom-left-radius: 11px;
    border-top-left-radius: 11px;
    width: 24px;
    background: #d8d8d8;
    display: flex;
    align-items: center;
    text-align: center;
    color: #212121;
  }
  .preNumber {
    margin-top: 24px;
    .Mui-disabled {
      color: #fff;
      background-color: #1565c0;
      box-shadow: none;
    }
  }

  .preNumber_detail {
    display: flex;
    margin-top: 24px;
    button {
      padding-right: 0px;
      width: 80px;
      height: 36px;
    }
    .num_count {
      margin-left: 48px;
      font-size: 24px;
    }
  }
  .setting_share {
    margin-top: 32px;
    label: {
      margin-right: 0;
    }
    .return_num {
      margin-top: 5px;
      input {
        text-align: right;
      }
    }
  }
  .label_name {
    color: #212121;
  }
`;
